import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { CoreService } from './core.service'
import { User } from 'depoto-core/src/entities'
import { daysBetweenDates } from '../utils'

const storageKey = 'hs-trial-daily-modal-shown-at'

@Injectable({
  providedIn: 'root',
})
export class TrialService {
  isUserLoaded: boolean
  doesTrialExpired: boolean
  shouldDisplayBottomInfoBanner: boolean
  shouldDisplayInfoModal: boolean
  trialDaysTillEnd: number
  constructor(
    private readonly translateService: TranslateService,
    private readonly core: CoreService,
  ) {
    this.core.services.user.currentUserEmitter.subscribe().then((user: User) => {
      if (user?.email && user?.locale && user?.company) {
        this.isUserLoaded = true
        // console.log('trialServ user loaded on init', { user })
        if (user.company?.tariff?.id === 'trial') {
          this.trialDaysTillEnd = daysBetweenDates(new Date(), new Date(user.company.tariffExpirationDate)) + 1
          // this.trialDaysTillEnd = daysBetweenDates(new Date(), new Date('2024-09-17 00:00:00'))
          // console.log('trialServ daysTillEnd: ', this.trialDaysTillEnd)
          if (this.trialDaysTillEnd < 99999 && this.trialDaysTillEnd > -1) {
            this.shouldDisplayBottomInfoBanner = true
          }
          if (this.trialDaysTillEnd <= 7 && this.trialDaysTillEnd > -1) {
            this.showDailyModal()
          }
          if (this.trialDaysTillEnd < 0) {
            this.doesTrialExpired = true
          }
        }
      }
    })
  }

  showDailyModal() {
    // window.localStorage.removeItem(storageKey) // todo testing, uncomment to display modal every time
    const lastShownDateString = window.localStorage.getItem(storageKey)
    const lastShownDate = lastShownDateString?.length ? new Date(lastShownDateString) : null
    const lastShownDay = lastShownDate?.getDate() || 99
    const today = new Date().getDate()
    // console.log({ lastShownDay, today })
    if (lastShownDay !== today) {
      this.shouldDisplayInfoModal = true
    }
  }

  hideDailyModal() {
    this.shouldDisplayInfoModal = false
    window.localStorage.setItem(storageKey, new Date().toISOString())
  }

  getFullVersion() {
    window.open('https://www.evidentist.cz/objednavka', '_blank')
  }
}
